const PATH_DELIMTER = '/';

export function joinPaths(path1: string, path2: string) {
  if (!path1 && !path2) {
    return '';
  }
  if (path1 && !path2) {
    return path1;
  }
  if (!path1 && path2) {
    return path2;
  }
  if (path1.endsWith(PATH_DELIMTER) && path2.startsWith(PATH_DELIMTER)) {
    return `${path1}${path2.substring(1)}`;
  }
  if (!path1.endsWith(PATH_DELIMTER) && !path2.startsWith(PATH_DELIMTER)) {
    return `${path1}${PATH_DELIMTER}${path2}`;
  }
  return `${path1}${path2}`;
}
